import { useEffect, useState } from 'react';

/**
 * מופיע כשגרסה חדשה של האפליקציה כבר ירדה ומוכנה אבל לא נטענה מעצמה — כי המשתמש כבר באמצע שימוש
 * (ראו main.tsx). בלחיצה נטענת הגרסה החדשה; גם בלי לחיצה היא תיטען כשהמסך ייעלם/ייסגר.
 */
export function UpdateBanner() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const onReady = () => setReady(true);
    window.addEventListener('pmr-update-ready', onReady);
    return () => window.removeEventListener('pmr-update-ready', onReady);
  }, []);

  if (!ready) return null;
  return (
    <div className="update-banner" role="status">
      <span>גרסה חדשה של האפליקציה מוכנה.</span>
      <button type="button" className="btn btn--primary btn--sm" onClick={() => window.location.reload()}>
        עדכן עכשיו
      </button>
    </div>
  );
}
